import React from 'react';

export function ProjectPersonnelCosts() {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Chi phí nhân sự</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Chi tiết</button>
      </div>

      <div className="space-y-4">
        <div className="space-y-1">
           <p className="text-xl font-normal text-slate-900">1.685.200.000 <span className="text-xs font-normal text-slate-400">VND</span></p>
           <p className="text-xs font-normal text-emerald-600">24% Tổng chi phí dự án</p>
        </div>
        
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
           <div className="h-full bg-emerald-500" style={{ width: '24%' }} />
        </div>

        <div className="pt-2 border-t border-slate-50 grid grid-cols-2 gap-4">
           <div className="space-y-1">
              <p className="text-xs font-normal text-slate-400">Dự toán</p>
              <p className="text-xs font-normal text-slate-700">7.021.000.000</p>
           </div>
           <div className="space-y-1 text-right">
              <p className="text-xs font-normal text-slate-400">Còn lại</p>
              <p className="text-xs font-normal text-slate-700">5.335.800.000</p>
           </div>
        </div>
      </div>
    </div>
  );
}
